import React, { useEffect, useState } from 'react';
import { WRITE_TAB, VIEW_TAB, EDITOR_TAB, PROFILE_TAB } from '../../constants';
// import SearchTab from './SearchTab';
import SearchTab from '../container/SearchTab';
import WriteTab from './WriteTab';
import ViewTab from './ViewTab';
import EditorCreateTab from './EditorCreateTab';
import ProfileTab from './profile_page/ProfileTab';

const ContentPane = ({ getDocumentId, documents, activeTab, searchDocuments, showDocument }) => {
    const [initTab, setInitTab] = useState();
    const [initDocument, setInitDocument] = useState(false);
    useEffect(() => {
        const documentId = getDocumentId();
        if (!initTab && documentId) {
            if (!documents || documents.length === 0) {
                if (!initDocument) { 
                    setInitDocument(true);
                    searchDocuments("*", {});
                }
            } else {
                const metadata = documents.find((doc) => { console.log("ContentPane Find", doc, doc.id, documentId); return doc.id.value === documentId });
                if (!metadata) {
                    console.log("Document not found", documentId);
                    return;
                };
                showDocument(metadata);
                setInitTab(VIEW_TAB);
            }
        }
    }, [documents]);

    console.log("--ACTIVE TAB RECEIVED...:" + activeTab);
    if (activeTab === WRITE_TAB) {
        return <WriteTab />
    }
    else if (activeTab === VIEW_TAB) {
        return <ViewTab />
    }
    else if (activeTab === EDITOR_TAB) {
        return <EditorCreateTab />
    }

    else if (activeTab === PROFILE_TAB) {
        return <ProfileTab />
    }

    else {
        return (<SearchTab />)
    }
}

export default ContentPane;

